<template>
  <div class="position">
    <div style="margin-bottom: 20px; font-size: 20px;">We sincerely hope we did not cause you any inconvenience</div>
    <div style="margin-bottom: 20px; font-size: 20px;">Cancel mailing?</div>
    <el-button @click="no" type="danger" round>No</el-button>
    <el-button @click="yes" type="success" round>Yes</el-button>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'mail-notification',
    components: {},
    data() {
      return {
        form: {
          email: null,
          type: null
        }
      }
    },
    created() {
      if (this.$route.query.email) this.form.email = this.$route.query.email
      if (this.$route.query.type) this.form.type = this.$route.query.type
    },
    methods: {
      yes() {
        let loader = this.$loading.show();
        axios
          .post('/api/v1/mailNotification/unsubscribe', {
            email: this.form.email,
            type: this.form.type
          })
          .then(response => {
            // Handle success.
            // this.notification("Success", "Successfully verified", "success")

            this.$router.push('/login');
            loader.hide()
          })
          .catch(error => {
            // Handle error.
            console.log('An error occurred:', error);
            // this.notification("Notification", error.response.data.message, "info")
            loader.hide()
          });
      },
      no() {
        this.$router.push('/login');
      }
    }
  }
</script>

<style lang="scss" scoped>
.position {
  margin-top: 350px;
  text-align: center;
}
</style>